// @flow
import iniOContentOverlayGallery from './OContentOverlayGallery';

// ini on load
window.addEventListener('DOMContentLoaded', () => {
	iniOContentOverlayGallery(document);

	console.log('%cSite overlay is ready', 'background: #8be09f; color: #39485e');
});
